import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { BMApiService } from '../../../services/bm.service';
import { Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { formatDate } from '@angular/common';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UtilityService } from '../../../services/utility.service';
import { AdminApiService } from '../../../services/admin.service';
import { tranbenchmarkkpi, tranbenchmarkkpihistory, benchmarkkpiposition, kpi, bmincoming, surveyQuestionMaster, bmsurveyQuestion, bmincomingattendees } from '../../../models/slakpi';
import { division } from '../../../models/admin';

import { ToasterService } from '../../../toaster.service';
@Component({
  selector: 'app-bench-mark-incoming-transaction',
  templateUrl: './bench-mark-incoming-transaction.component.html',
  styleUrls: ['./bench-mark-incoming-transaction.component.css']
})
export class BenchMarkIncomingTransactionComponent implements OnInit {
  
  objBM: any = new bmincoming();
  selTab: boolean = true;
  submitted: boolean = false;
  columnAtdDefinitions: Column[];
  atdGrid: AngularGridInstance;
  datasetAtd: any;
  invalid: boolean = false;
  public visitor_data: any;
  public organizationType_data: any;  
  public division_data: any;
  public letterStatus_data: any;
  public MDCEOResponse_data: any;
  public LogisticStatus_data: any;
  public VisitStatus_data: any;
  public Delegated_data: any;
  public benchMarkYear_data: any;
  public currentHalf_data: any;
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
 

  columnDefinitions_Approve: Column[];
  gridOptions_Approve: GridOption;
  dataset_Approve: any;
  angularGrid_Approve: AngularGridInstance;
  public BMIncoming_data_Approve: any;

  yearfilter: any;
  divisionUnofilter: any;
  halffilter: any;
  positionfilter: any;
  public loading: boolean = true;
  public pageAction: string = 'add';
  isStart: boolean = true;
  @ViewChild('addAttendeeTemplate', { static: false }) addAttendeeTemplate: TemplateRef<any>;
  @ViewChild('surveyUpdateTemplate', { static: false }) surveyUpdateTemplate: TemplateRef<any>; 
  //for Users Default Value
  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean;
 
  selectedItem: any; 
  bmIncomingID: any;
  public selectedEditItemIndex: number;
  public isBMChampion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
  searchText: string;
  dataSearch: any;
  noDataImg: any;
  tenantUno: any;
    editID: any;
  constructor(public restApi: BMApiService, private toaster: ToasterService, public restAdminApi: AdminApiService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.isAdmin = (this.user.role == 'Administrator') ? true : false;
    this.ValidateUserAccess();
  }
  //Method used To Validate User Permission
  ValidateUserAccess() {
    

    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;

    if (this.user.role == 'BM Champions')
      this.isBMChampion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("Incoming Benchmarking Request Transaction");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }

  }
  ngOnInit() {
    this.userService.CheckLogin();
    this.gridOptions_Approve = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
   

    this.LoadBMIncomingApproved_Data();

  }

  
  angularGridReady_Approve(angularGrid: AngularGridInstance) {
    this.angularGrid_Approve = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  
  
  angularAtdGridReady(angularGrid: AngularGridInstance) {
    this.atdGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }


  

  dateFormat(value) {
    if (value)
      return formatDate(value, 'yyyy-MM-dd', 'en-US');
    else
      return null;
  }
  getAttendee(id) {
    this.columnAtdDefinitions = [];
    let inpValue = new bmincomingattendees();
    inpValue.visitTrackUno = id;
    inpValue.condition = 0;
    inpValue.userUno = this.login_UserID;
    this.restApi.getBMIncomingAtd(inpValue)
      .subscribe(data => {
        this.datasetAtd = data;
        this.setAtdDefn();
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  setAtdDefn() {
    this.columnAtdDefinitions = [
      { id: 'firstName', name: 'First Name', field: 'firstName', sortable: true},
      { id: 'lastName', name: 'Last Name', field: 'lastName', sortable: true },
      { id: 'email', name: 'Email', field: 'email', sortable: true },
      { id: 'mobileNumber', name: 'Mobile Number', field: 'mobileNumber', sortable: true },
      {
        id: 'attendance', name: 'Attendance', field: 'attendance', sortable: true,
        type: FieldType.string, 
        formatter: (row, cell, val, columnDef, data) => {
          if (data.attendance == 0)
            return '<span  class="status-area status-gray">NA</span>';
          else if (data.attendance == 1)
            return '<span  class="status-area status-green">Present</span>';
          else if (data.attendance == 2)
            return '<span  class="status-area status-red">Absent</span>';
         
        }
      },
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 35,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [


            {
              command: 'Servey-row', titleKey: 'Servey_ROW', positionOrder: 66, title: 'Start Survey',
              iconCssClass: 'fa fa-lg fa-info-circle', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
               
                let rdata: any = args.dataContext;
                this.router.navigate([]).then(result => { window.open('/#/survey-view/' + rdata.visitTrackUno + '?atdUno='+rdata.bmIncomingAttendeeUno, '_blank'); });
              },
              //  // only show command to 'Delete Row' when the task is not completed

            },
            {
              command: 'Servey-row', titleKey: 'Servey_ROW', positionOrder: 67, title: 'Present',
              iconCssClass: 'fa fa-lg fa-user-plus', cssClass: 'green', textCssClass: 'bold',
              action: (e, args) => {
                
                let rdata: any = args.dataContext;
                this.onClickAttendance(rdata.bmIncomingAttendeeUno, 1);
                
              },
              //  // only show command to 'Delete Row' when the task is not completed

            },
            {
              command: 'Servey-row', titleKey: 'Servey_ROW', positionOrder: 68, title: 'Absent',
              iconCssClass: 'fa fa-lg fa-user-times', cssClass: 'red', textCssClass: 'bold',
              action: (e, args) => {

                let rdata: any = args.dataContext;
                this.onClickAttendance(rdata.bmIncomingAttendeeUno,2);
              },
              //  // only show command to 'Delete Row' when the task is not completed

            },
          ],
        }
      }

    ];
  }
  
  onDbClicked(ev, args) {
    
   //    this.router.navigateByUrl('/benchmarkkpiview/' + rdata.id);
    return false;
  }

  LoadBMIncomingApproved_Data() {
    

    let inpValue = new bmincoming();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getBMIncoming(inpValue)
      .subscribe((data: any) => {
        
        let rtn_data = data;
       
        const mockDataset = [];
        this.dataset_Approve = [];
        if (rtn_data != null && rtn_data.length > 0) {

          //uniqBy(data, 'kpiUno');

          for (let i = 0; i < rtn_data.length; i++) {

            

            mockDataset[i] = {
              id: rtn_data[i].visitTrackUno,
              requestFrom: rtn_data[i].requestFrom,
              visitorFrom: rtn_data[i].visitorFrom,
              organizationType: rtn_data[i].organizationType,
              subject: rtn_data[i].subject,
              requestedTopics: rtn_data[i].requestedTopics,
              receivedOn: rtn_data[i].receivedOn,
              locationorVenue: rtn_data[i].locationorVenue,
              bmChampionProposedDateOn: rtn_data[i].bmChampionProposedDateOn,
              concernedDivisionorTeam: rtn_data[i].concernedDivisionorTeam,
              conductedVisitorRemoteMeetingOn: rtn_data[i].conductedVisitorRemoteMeetingOn,
              delegatesConfirmedOn: rtn_data[i].delegatesConfirmedOn,
              delegatesFilledOn: rtn_data[i].delegatesFilledOn,
              forwardedtoConcerenedDivisionOn: rtn_data[i].forwardedtoConcerenedDivisionOn,
              letterStatus: rtn_data[i].letterStatus,
              logisticsStatus: rtn_data[i].logisticsStatus,
              mdceoResponse: rtn_data[i].mdceoResponse,
              officialReplySentOn: rtn_data[i].officialReplySentOn,
              replySentTo: rtn_data[i].replySentTo,
              submittedInSmartDocumentOn: rtn_data[i].submittedInSmartDocumentOn,
              letterReferenceNo: rtn_data[i].letterReferenceNo,
              isDelegatesFilled: rtn_data[i].isDelegatesFilled,
              visitRemoteMeetingStatus: rtn_data[i].visitRemoteMeetingStatus,
              freceivedOn: formatDate(rtn_data[i].receivedOn, 'dd-MM-yyy', 'en-US'),
              satisfactionRate: (rtn_data[i].satisfactionRate != "") ? rtn_data[i].satisfactionRate : 0,
              satisfactionRateString:  rtn_data[i].satisfactionRate.tostring
            };
          }
          this.dataset_Approve = mockDataset;
          this.dataSearch = mockDataset;
          if (mockDataset.length > 0) {
            this.setColnDefn_Approve();
          }
          this.BMIncoming_data_Approve = rtn_data;

          this.isStart = false;
          this.loading = false;
          this.spinner.hide()
        }
        else {
          this.dataset_Approve = [];
          this.isStart = false;
          this.loading = false;
          this.spinner.hide()
        }
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  searchGrid() {
    if (this.searchText != "") {
      this.dataset_Approve = this.dataSearch.filter(a =>
        a.requestFrom && a.requestFrom.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.visitorFrom && a.visitorFrom.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.organizationType && a.organizationType.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.receivedOn && a.receivedOn.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.subject && a.subject.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.requestedTopics && a.requestedTopics.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.mdceoResponse && a.mdceoResponse.toLowerCase().includes(this.searchText.toLowerCase()))
        //|| (a.satisfactionRateString && a.satisfactionRateString.toLowerCase().includes(this.searchText.toLowerCase()))
      );
    }
    else
      this.dataset_Approve = this.dataSearch;
  }

  setColnDefn_Approve() {
    let temp = this;
    this.columnDefinitions_Approve = [
      {
        id: 'requestFrom', name: 'Request From', field: 'requestFrom', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset_Approve, 'requestFrom', 'requestFrom'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'visitorFrom', name: 'Visitor From', field: 'visitorFrom', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset_Approve, 'visitorFrom', 'visitorFrom'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'organizationType', name: 'Organization Type', field: 'organizationType', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset_Approve, 'organizationType', 'organizationType'),
          model: Filters.multipleSelect,
        }
      },
      //{
      //  id: 'receivedOn', name: 'Received On', field: 'freceivedOn', sortable: true,
      //  type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset_Approve, 'freceivedOn', 'freceivedOn'),
      //    model: Filters.multipleSelect,
      //  }
      //},
      //{
      //  id: 'subject', name: 'Subject', field: 'subject', sortable: true,
      //  type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset_Approve, 'subject', 'subject'),
      //    model: Filters.multipleSelect,
      //  }
      //},

      {
        id: 'requestedTopics', name: 'Requested Topics', field: 'requestedTopics', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset_Approve, 'requestedTopics', 'requestedTopics'),
          model: Filters.multipleSelect,
        }
      },
      //{
      //  id: 'mdceoResponse', name: 'Status', field: 'mdceoResponse', sortable: true,
      //  type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset_Approve, 'mdceoResponse', 'mdceoResponse'),
      //    model: Filters.multipleSelect,
      //  }
      //},
      {
        id: 'visitRemoteMeetingStatus', name: 'Status', field: 'visitRemoteMeetingStatus', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset_Approve, 'visitRemoteMeetingStatus', 'visitRemoteMeetingStatus'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'satisfactionRate', name: 'Satisfaction Rate', field: 'satisfactionRate', sortable: true,
        formatter: (row, cell, val, columnDef, data) => {
          let per = data.satisfactionRate;

          return '<div class="progress" style="height: 15px; font-size:9px; text-indent: 2px; background-color:#999;"><div class="progress-bar bg-d-green text-left" role = "progressbar" style = "width:' + per + '%;" aria-valuenow="' + per + '" aria-aluemin="0" aria - valuemax="100" > ' + per + '% </div></div>';

        },
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset_Approve, 'satisfactionRate', 'satisfactionRate'),
          model: Filters.multipleSelect,
        }
      },
      //{
      //  id: 'locationorVenue', name: 'Location', field: 'locationorVenue', sortable: true,
      //  type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset_Approve, 'locationorVenue', 'locationorVenue'),
      //    model: Filters.multipleSelect,
      //  }
      //},


      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Update Survey Result',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMAdmin || this.isAdmin)
                  return true;
                else
                  return false;
              },
              iconCssClass: 'fa fa-edit', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.editID = rdata.id;
                this.objBM = rdata;


                this.modalRef = this.modalService.show(
                  this.surveyUpdateTemplate,
                  Object.assign({}, { class: 'gray modal-medium' })
                );

              },
              // only show command to 'Delete Row' when the task is not completed

            },
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Start Survey',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-lg fa-info-circle', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'view';
                
                let rdata: any = args.dataContext;
                
                
               // this.router.navigateByUrl('/survey-view/' + rdata.id, '_blank');
                
                this.router.navigate([]).then(result => { window.open('/#/survey-view/' + rdata.id, '_blank'); });

              },
              //  // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 63 },

            {
              command: 'atd-row', titleKey: 'atd_ROW', positionOrder: 64, title: 'Attendee',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-lg fa-user-circle', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'view';
                let rdata: any = args.dataContext;

                this.objBM = rdata;
                this.bmIncomingID = rdata.id;
                this.getAttendee(this.bmIncomingID);

                this.modalRef = this.modalService.show(
                  this.addAttendeeTemplate,
                  Object.assign({}, {
                    class: 'gray modal-lg',
                    backdrop: true,
                    keyboard: true,
                    focus: true,
                    show: false,
                    ignoreBackdropClick: true,
                    animated: true
                  })
                );

              },
              //  // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 65 },
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 66, title: 'View Survey',
              iconCssClass: 'fa fa-lg fa-info-circle', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'view';
                
                let rdata: any = args.dataContext;


                // this.router.navigateByUrl('/survey-view/' + rdata.id, '_blank');

                this.router.navigate([]).then(result => { window.open('/#/survey-report/' + rdata.id, '_blank'); });

              }
            },


          ],
        }
      }




    ]


  }
 
  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }
  onClickAttendance(attendeeID: number, attendance:number) {
   
      let objBMIncomingAttendees = new bmincomingattendees();
      objBMIncomingAttendees.bmIncomingAttendeeUno =attendeeID;
      objBMIncomingAttendees.attendance = attendance;
      objBMIncomingAttendees.condition = (attendance==1)?6:7; // 6--Present 7--Absent
    
    objBMIncomingAttendees.userUno = this.login_UserID;
      this.restApi.addEditBMIncomingAttendees(objBMIncomingAttendees)
        .subscribe(data => {

          
          if (data != null && data != 'failure') {
            
            this.toaster.show('success', 'Success', 'Attendance updated');
            //this.modalRef.hide();
            
            setTimeout(() => { this.spinner.hide(); this.getAttendee(this.bmIncomingID);}, 900);
          }
          else {
            //Swal.fire('Error', 'Something went wrong', 'error');
            this.toaster.show('error', 'Error', 'Something went wrong');
            this.spinner.hide();
          }

         


        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
    
    return false;
  }

  onSurveySubmit(val1) {
    
    if (!val1) {
      this.toaster.show('error', 'Error', 'Please enter all the required fields.');
      return
    }

    else {
      let obj = new bmincoming();
      obj.id = (this.editID) ? this.editID : 0;
      obj.mdceoResponse = this.objBM.satisfactionRate;

      obj.userUno = this.login_UserID;
      obj.flag = 'bmincoming_surveyresult';
      this.restApi.updateBMIncomingStatus(obj)
        .subscribe(data => {
          
          if (data != null && data != undefined && data != '' && data != 'failure') {
            this.toaster.show('success', 'Success', 'Survey result updated.');
            setTimeout(() => {
              this.objBM = new bmincoming();
              this.spinner.hide();
              this.LoadBMIncomingApproved_Data();
              this.modalRef.hide();
            }, 500);

          }
          else {

            this.toaster.show('error', 'Error', 'Something went wrong');
            this.spinner.hide();

          }



        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });





    }
  }
}
